import { SessionMixin, ThumbnailType, ImageFormat, cdnService, ImageFit, FeatureEnabledV2, waitForImage, scroll } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { GAMES_LIST, USER_JURISDICTION_UPDATED, Feature } from '@gig/magic-messages';
import { CtaStyle } from '@gig/magic-sdk/dist/util/interfaces';
import '../../mixins/static-page.mixin.js';
import { PromotionsMixin } from '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import { CompetitionsMixin } from '../../mixins/competitions.mixin.js';
import { isUKGC, isSGA } from '@gig/magic-jurisdictions';
import { PromotionsOptinMixin } from '../../mixins/promotions-optin.mixin.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const BLOCK_DEMO_IGC_TAG = "BlockDemoWithChildTheme";
let PromotionComponent = class extends Mixins(PromotionsMixin, PromotionsOptinMixin, SessionMixin, CompetitionsMixin) {
  constructor() {
    super(...arguments);
    this.isOptingIn = false;
    this.games = new Map();
    this.gamesListSubscription = null;
    this.promotionGamesEnabled = false;
    this.thumbnailType = ThumbnailType.PROMOTION_GAMES;
    this.isUKGCJurisdiction = false;
    this.isSGAJurisdiction = false;
    this.userJurisdictionSubscription = null;
  }
  created() {
    this.gamesListSubscription = window.eventBus.subscribe(GAMES_LIST, (e) => {
      var _a;
      this.games = (_a = e.payload) != null ? _a : new Map();
    }, { replay: true });
    this.userJurisdictionSubscription = window.eventBus.subscribe(USER_JURISDICTION_UPDATED, (event) => {
      this.isUKGCJurisdiction = isUKGC(event.payload);
      this.isSGAJurisdiction = isSGA(event.payload);
    }, { replay: true });
  }
  destroyed() {
    var _a, _b;
    (_a = this.gamesListSubscription) == null ? void 0 : _a.unsubscribe();
    (_b = this.userJurisdictionSubscription) == null ? void 0 : _b.unsubscribe();
  }
  get promotion() {
    if (!this.promotions) {
      return null;
    }
    return this.promotions.find(({ slug }) => slug === this.slug) || null;
  }
  get isOptInPromo() {
    if (!this.promotion) {
      return false;
    }
    const promotionsArray = this.promotion.values.cta.filter((cta) => {
      return this.isOptIn(cta);
    });
    return promotionsArray.length === 0 || this.isOptedIn;
  }
  get isOptedIn() {
    if (!this.promotion || !this.isLoggedIn) {
      return false;
    }
    const optInCta = this.promotion.values.cta.find(this.isOptIn);
    if (!optInCta || !optInCta.roles || optInCta.roles.length === 0) {
      return false;
    }
    return optInCta.roles.every((role) => this.userRoles.includes(role));
  }
  get background() {
    if (!this.promotion || !this.promotion.background) {
      return null;
    }
    const imageParams = {
      width: 1,
      height: 1,
      format: ImageFormat.WEBP
    };
    if (this.isMobile && this.promotion.mobileBackground) {
      return cdnService.getPromotionMobileBackgroundUrl(this.promotion.mobileBackground, imageParams);
    }
    return cdnService.getPromotionBackgroundUrl(this.promotion.background, imageParams);
  }
  get src() {
    return this.getImage(ImageFormat.WEBP);
  }
  get avifSrcset() {
    return this.getImageSrcset(ImageFormat.AVIF);
  }
  get webpSrcset() {
    return this.getImageSrcset(ImageFormat.WEBP);
  }
  get promotionGames() {
    var _a, _b;
    const gameSlugs = new Set();
    (_b = (_a = this.promotion) == null ? void 0 : _a.values.games) == null ? void 0 : _b.forEach((game) => {
      gameSlugs.add(game.slug);
    });
    const promotionGames = Array.from(gameSlugs.values()).map((slug) => {
      return this.games.get(slug);
    }).filter((game) => !!game);
    return !this.isLoggedIn ? promotionGames.filter((game) => !(game.igcTags || []).includes(BLOCK_DEMO_IGC_TAG)) : promotionGames;
  }
  get hasPromotionGames() {
    return this.promotionGames.length > 0;
  }
  get shouldShowTerms() {
    return this.showTerms || this.isUKGCJurisdiction || this.isSGAJurisdiction;
  }
  getImageSrcset(format) {
    if (!this.promotion || !this.promotion.image) {
      return null;
    }
    return this.widths.map((width) => `${this.getImage(format, width)} ${width}w`).join(", ");
  }
  getImage(format, width = 1) {
    if (!this.promotion || !this.promotion.image) {
      return null;
    }
    return cdnService.getPromotionImageUrl(this.promotion.image, {
      width,
      fit: ImageFit.MAX,
      format
    });
  }
  onCtaClick(cta, event) {
    var _a;
    if (!this.isOptIn(cta) || this.isOptedIn) {
      return;
    }
    event.preventDefault();
    this.optIn((_a = this.promotion) == null ? void 0 : _a.name, cta);
  }
  isLink(cta) {
    return cta.style === CtaStyle.LINK;
  }
  onPromotionsLoad() {
    if (!this.isLoading && this.promotions.length > 0 && !this.promotion) {
      this.handleNotFound();
      return;
    }
    this.openTerms();
  }
  handleNotFound() {
    return;
  }
  openTerms() {
    return __async(this, null, function* () {
      yield this.$nextTick();
      if (!this.showTerms || !this.$refs.terms) {
        return;
      }
      yield waitForImage(this.$refs.header);
      scroll.scrollTo(this.$refs.terms);
    });
  }
};
__decorateClass([
  Prop(String)
], PromotionComponent.prototype, "slug", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], PromotionComponent.prototype, "showTerms", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], PromotionComponent.prototype, "isMobile", 2);
__decorateClass([
  Prop({ type: Array, default: () => [] })
], PromotionComponent.prototype, "widths", 2);
__decorateClass([
  FeatureEnabledV2({ slug: Feature.PROMOTION_GAMES })
], PromotionComponent.prototype, "promotionGamesEnabled", 2);
__decorateClass([
  Watch("isLoading", { immediate: true }),
  Watch("promotions")
], PromotionComponent.prototype, "onPromotionsLoad", 1);
__decorateClass([
  Emit("notFound")
], PromotionComponent.prototype, "handleNotFound", 1);
PromotionComponent = __decorateClass([
  Component({
    name: "promotion"
  })
], PromotionComponent);

export default PromotionComponent;
